<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" width="800px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :inline="true" :model="searchForm" :rules="rules" label-width="110px">
            <el-form-item label="出库交接人" prop="delivererBy" style="width: 48%">
                <el-select v-model="searchForm.delivererBy"
                           placeholder="请选择出库交接人" style="width: 100%"
                           clearable>
                    <el-option
                        v-for="item in delivererByList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="入库接收人" prop="receiverBy"  style="width: 48%">
                <el-select v-model="searchForm.receiverBy"
                           placeholder="请选择入库接收人" style="width: 100%"
                           clearable>
                    <el-option
                        v-for="item in delivererByList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出库时间" prop="receiverTime"  style="width: 48%">
                <el-date-picker
                    style="width: 100%"
                    v-model="searchForm.receiverTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择出库时间">
                </el-date-picker>
            </el-form-item>
            <div class="minTitle">出库藏品：</div>
            <el-table
                :data="dataList"
                size="small" height="250px"
                class="table" ref="multipleTable" border
                row-key='id' v-loading="loading">
                <el-table-column prop="dataName" label="资源名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="warehouseName" label="存放库房" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shelfName" label="存放位置" show-overflow-tooltip></el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="current" :limit.sync="size"
                        @pagination="getDetail"/>
        </el-form>
        <div slot="footer" class="text_right">
            <el-button size="small" type="primary" @click="sureData()" v-noMoreClick>确定</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "sureOutbound",
    data(){
        return{
            title:'批量出库确认',
            visible:false,
            searchForm:{
                delivererBy:'',
                receiverBy:'',
                receiverTime:'',
            },
            rules:{
                delivererBy: [
                    {required: true, message: '请选择出库交接人', trigger: 'change'}
                ],
                receiverBy: [
                    {required: true, message: '请选择入库接收人', trigger: 'change'}
                ],
                receiverTime: [
                    {required: true, message: '选择出库时间', trigger: 'change'}
                ],
            },
            delivererByList:[],
            loading:false,
            dataList: [],
            current:1,
            size:20,
            total: 0,
            selectData:{},
        }
    },

    methods:{
        init(row){
            this.visible = true
            this.selectData = row
            this.$nextTick(()=>{
                this.$refs.searchForm.resetFields()
            })
            this.current = 1
            this.size = 20
            this.getOtherData()
            this.getDetail()
        },

        getOtherData(){
            this.$axios(this.api.user.queryUserListAllUsable).then(data => {
                if (data && data.status) {
                    this.delivererByList = data.data
                }
            })
        },

        getDetail(){
            this.loading = true
            this.$axios(this.api.collection.confirmOutboundInfo, {
                id:this.selectData.id,
                current:this.current,
                size:this.size,
            }).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                }
                this.loading = false
            })
        },

        sureData(){
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.$axios(this.api.collection.confirmOutbound, {
                        ...this.searchForm,
                        orderId:this.selectData.id
                    },'post').then(data => {
                        if (data && data.status) {
                            this.$message.success('确定出库成功')
                            this.visible = false
                            this.$emit('refresh')
                        }else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            });
        },
    },
}
</script>

<style scoped>
.minTitle{
    width: 110px;
    text-align: right;
}
</style>